import React from 'react';
import Button from '@material-ui/core/Button';
import ChartLine from './chart-line-components/ChartLine';
import ChartCorrelation from './chart-corr-components/ChartCorrelation';
import ChartNothing from './chart-nothing-components/ChartNothing';
import cn from 'classnames';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';

interface Props {
  className?: string;
}

const ChartMain: React.FC<Props> = React.memo(({ className }) => {
  const NotLaunching = () => {
    window.alert('Not Launching Page');
  };

  return (
    <div
      className={cn(
        className,
        'min-h-screen max-w-screen-lg text-center pt-20 text-black mx-auto',
      )}>
      <div className="text-xs space-x-6">
        <Link to="/chart/line">
          <Button>LINE</Button>
        </Link>
        <Link to="/chart/line">
          <Button onClick={() => NotLaunching()}>CORRELATION</Button>
        </Link>
        <Link to="/chart/line">
          <Button onClick={() => NotLaunching()}>NOTHING</Button>
        </Link>
      </div>
      <div className="px-6">
        <Route path="/chart/line" component={ChartLine} />
        <Route path="/chart/correlation" component={ChartCorrelation} />
        <Route path="/chart/nothing" component={ChartNothing} />
      </div>
    </div>
  );
});
export default ChartMain;
